<button class="d-flex justify-content-between"
        (click)="onClick($event)">
  <ng-container *ngIf="value; else ValueFalse">
    <img src="./assets/icons/line-icons/shared/green/check.svg" width="16px" />
  </ng-container>
  <ng-template #ValueFalse>
    <img src="./assets/icons/line-icons/shared/red/x.svg" width="12px" />
  </ng-template>
</button>
